import React, { useState } from "react";
import { Modal, Button, Flex } from "antd";
import { mixPostV1 } from "../../../services/mixin";
import "./PaymentConfirmationModal.scss";

interface Props {
  isShow: boolean;
  storeName: string;
  income: string | number;
  storeId: string | number;
  onClose: () => void;
  onSuccess: () => void;
}

const PaymentConfirmationModal: React.FC<Props> = ({
  isShow,
  storeName,
  income = 0,
  storeId,
  onClose,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const handleManualPayment = async () => {
    setLoading(true);
    try {
      await mixPostV1("/api/webAdmin/manualPayment.php", {
        store_id: String(storeId),
      });
      onSuccess();
      onClose();
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={isShow}
      onCancel={onClose}
      footer={null}
      title={null}
      width={400}
      maskStyle={{ background: "rgba(0,0,0,0.85)" }}
      className="full-dark-modal"
    >
      <div className="pcm-title">Confirmation</div>
      <div className="pcm-content">
        Are you confirm <b>payment manual ${income}</b> for store{" "}
        <b>{storeName}</b>
      </div>
      <Flex justify="center" gap={16}>
        <Button className="pcm-cancel-btn" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          className="pcm-payment-btn"
          type="primary"
          onClick={handleManualPayment}
          loading={loading}
        >
          Payment
        </Button>
      </Flex>
    </Modal>
  );
};

export default PaymentConfirmationModal;
